var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58463 13.8447L8.28444 13.4526H7.79063H4V4.00024H16V13.4526H12.2094H11.7156L11.4154 13.8447L10 15.6934L8.58463 13.8447ZM3.59063 3.00024H16.4094C16.7594 3.00024 17 3.26215 17 3.6431V13.8098C17 14.1907 16.7594 14.4526 16.4094 14.4526H12.2094L10.4594 16.7383C10.35 16.9288 10.175 17.0002 10 17.0002C9.825 17.0002 9.65 16.8574 9.54063 16.7383L7.79063 14.4526H3.59063C3.24063 14.4526 3 14.1907 3 13.8098V3.6431C3 3.26215 3.24063 3.00024 3.59063 3.00024ZM6 5.5C5.72386 5.5 5.5 5.72386 5.5 6C5.5 6.27614 5.72386 6.5 6 6.5H13C13.2761 6.5 13.5 6.27614 13.5 6C13.5 5.72386 13.2761 5.5 13 5.5H6ZM6 8C5.72386 8 5.5 8.22386 5.5 8.5C5.5 8.77614 5.72386 9 6 9H11C11.2761 9 11.5 8.77614 11.5 8.5C11.5 8.22386 11.2761 8 11 8H6ZM6 10.5C5.72386 10.5 5.5 10.7239 5.5 11C5.5 11.2761 5.72386 11.5 6 11.5H14C14.2761 11.5 14.5 11.2761 14.5 11C14.5 10.7239 14.2761 10.5 14 10.5H6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopDetails);
export default __webpack_public_path__ + "static/media/stop-details.f94d38d656c3694cb7bcfb9f5f8331cb.svg";
export { ForwardRef as ReactComponent };